import styled from 'styled-components';

const LogoWrapper = styled.div`
  display: flex;
  justify-content: center;
`;
export default LogoWrapper;
